import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 90%;
  margin: 0 auto 20px;
  min-height: 500px;
`;
